export interface SearchSubjectItem {
    "description": string,
    "categodyCode": string,
    "browseCatId": number,
    "url": string,
    "parentSubject": string,
    "qualCode": string
}

export interface SearchLocationItem {
    "regionId": number,
    "regionUrl": string | null,
    "regionName": string
}

export interface SearchUniItem {
    "collegeId": number,
    "collegeNameDisplay": string,
    "collegeTextKey": string,
    "collegeName": string
}

export enum SearchTabIntNames {
  Clearing = 'clearing - global',
  Course = 'courses - global',
  Uni = 'universities - global',
  Advice = 'advice - global'
}